// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReSchema from "./ReSchema.bs.jsx";
import * as ReactUpdate from "rescript-react-update/src/ReactUpdate.bs.jsx";
import * as ReSchemaI18n from "./ReSchemaI18n.bs.jsx";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";

function Make(Config) {
  let ReSchema$1 = ReSchema.Make(Config);
  let getInitialFieldsState = schema => schema.map(validator => [
    {
      TAG: "Field",
      _0: validator.field
    },
    "Pristine"
  ]);
  let formContext = React.createContext(undefined);
  let useFormContext = () => React.useContext(formContext);
  let useField = field => {
    let $$interface = React.useContext(formContext);
    return Stdlib_Option.map($$interface, param => {
      let validateField = param.validateField;
      let handleChange = param.handleChange;
      return {
        handleChange: value => handleChange(field, value),
        error: param.getFieldError({
          TAG: "Field",
          _0: field
        }),
        state: param.getFieldState({
          TAG: "Field",
          _0: field
        }),
        validate: () => validateField({
          TAG: "Field",
          _0: field
        }),
        value: Config.get(param.state.values, field)
      };
    });
  };
  let make = formContext.Provider;
  let Provider = {
    make: make
  };
  let ReForm$Make$Field = props => {
    let __renderOnMissingContext = props.renderOnMissingContext;
    let render = props.render;
    let __renderOnMissingContext_value = __renderOnMissingContext !== undefined ? __renderOnMissingContext : null;
    let fieldInterface = useField(props.field);
    return React.useMemo(() => Stdlib_Option.getOr(Stdlib_Option.map(fieldInterface, render), __renderOnMissingContext_value), [
      Stdlib_Option.map(fieldInterface, param => param.error),
      Stdlib_Option.map(fieldInterface, param => param.value),
      Stdlib_Option.map(fieldInterface, param => param.state)
    ]);
  };
  let Field = {
    make: ReForm$Make$Field
  };
  let use = (initialState, schema, onSubmit, onSubmitFailOpt, i18nOpt, validationStrategyOpt, param) => {
    let onSubmitFail = onSubmitFailOpt !== undefined ? onSubmitFailOpt : prim => {};
    let i18n = i18nOpt !== undefined ? i18nOpt : ReSchemaI18n.default;
    let validationStrategy = validationStrategyOpt !== undefined ? validationStrategyOpt : "OnChange";
    let match = ReactUpdate.useReducer((state, action) => {
      if (typeof action !== "object") {
        switch (action) {
          case "TrySubmit" :
            return {
              TAG: "SideEffects",
              _0: self => {
                self.send({
                  TAG: "ValidateForm",
                  _0: true
                });
              }
            };
          case "Submit" :
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                formState: "Submitting",
                values: state.values,
                fieldsState: state.fieldsState
              },
              _1: self => onSubmit({
                send: self.send,
                state: self.state,
                raiseSubmitFailed: error => self.send({
                  TAG: "RaiseSubmitFailed",
                  _0: error
                })
              })
            };
          case "ResetForm" :
            return {
              TAG: "Update",
              _0: {
                formState: "Pristine",
                values: initialState,
                fieldsState: getInitialFieldsState(schema)
              }
            };
        }
      } else {
        switch (action.TAG) {
          case "ValidateField" :
            let field = action._0;
            return {
              TAG: "SideEffects",
              _0: self => {
                let fieldState = ReSchema$1.validateOne(field, self.state.values, i18n, schema);
                let newFieldState;
                if (fieldState !== undefined) {
                  let message = fieldState[1];
                  newFieldState = typeof message !== "object" ? "Valid" : (
                      message.TAG === "NestedErrors" ? ({
                          TAG: "NestedErrors",
                          _0: message._0
                        }) : ({
                          TAG: "Error",
                          _0: message._0
                        })
                    );
                } else {
                  newFieldState = "Valid";
                }
                let newFieldsState = state.fieldsState.filter(param => Primitive_object.notequal(param[0], field)).concat([[
                    field,
                    newFieldState
                  ]]);
                self.send({
                  TAG: "SetFieldsState",
                  _0: newFieldsState
                });
              }
            };
          case "ValidateForm" :
            let submit = action._0;
            return {
              TAG: "SideEffects",
              _0: self => {
                let recordState = ReSchema$1.validate(i18n, self.state.values, schema);
                if (typeof recordState !== "object") {
                  let newFieldsState = self.state.fieldsState.map(param => [
                    param[0],
                    "Valid"
                  ]);
                  self.send({
                    TAG: "SetFieldsState",
                    _0: newFieldsState
                  });
                  if (submit) {
                    self.send("Submit");
                  }
                  self.send({
                    TAG: "SetFormState",
                    _0: "Valid"
                  });
                } else {
                  let newFieldsState$1 = recordState._0.map(param => [
                    param[0],
                    {
                      TAG: "Error",
                      _0: param[1]
                    }
                  ]);
                  self.send({
                    TAG: "SetFieldsState",
                    _0: newFieldsState$1
                  });
                  if (submit) {
                    let init = self.state;
                    onSubmitFail({
                      send: self.send,
                      state: {
                        formState: init.formState,
                        values: init.values,
                        fieldsState: newFieldsState$1
                      },
                      raiseSubmitFailed: error => self.send({
                        TAG: "RaiseSubmitFailed",
                        _0: error
                      })
                    });
                  }
                  self.send({
                    TAG: "SetFormState",
                    _0: "Errored"
                  });
                }
              }
            };
          case "SetFieldsState" :
            return {
              TAG: "Update",
              _0: {
                formState: state.formState,
                values: state.values,
                fieldsState: action._0
              }
            };
          case "FieldChangeState" :
            return "NoUpdate";
          case "FieldChangeValue" :
            let field$1 = action._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                formState: state.formState === "Errored" ? "Errored" : "Dirty",
                values: Config.set(state.values, field$1, action._1),
                fieldsState: state.fieldsState
              },
              _1: self => {
                if (validationStrategy === "OnChange") {
                  self.send({
                    TAG: "ValidateField",
                    _0: {
                      TAG: "Field",
                      _0: field$1
                    }
                  });
                }
              }
            };
          case "FieldChangeValueWithCallback" :
            let field$2 = action._0;
            let oldValue = Config.get(state.values, field$2);
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                formState: state.formState === "Errored" ? "Errored" : "Dirty",
                values: Config.set(state.values, field$2, action._1(oldValue)),
                fieldsState: state.fieldsState
              },
              _1: self => {
                if (validationStrategy === "OnChange") {
                  self.send({
                    TAG: "ValidateField",
                    _0: {
                      TAG: "Field",
                      _0: field$2
                    }
                  });
                }
              }
            };
          case "FieldArrayAdd" :
            let field$3 = action._0;
            return {
              TAG: "Update",
              _0: {
                formState: state.formState,
                values: Config.set(state.values, field$3, Config.get(state.values, field$3).concat([action._1])),
                fieldsState: state.fieldsState
              }
            };
          case "FieldArrayUpdateByIndex" :
            let index = action._2;
            let value = action._1;
            let field$4 = action._0;
            return {
              TAG: "Update",
              _0: {
                formState: state.formState,
                values: Config.set(state.values, field$4, Config.get(state.values, field$4).map((currentValue, i) => {
                  if (i === index) {
                    return value;
                  } else {
                    return currentValue;
                  }
                })),
                fieldsState: state.fieldsState
              }
            };
          case "FieldArrayRemove" :
            let index$1 = action._1;
            let field$5 = action._0;
            return {
              TAG: "Update",
              _0: {
                formState: state.formState,
                values: Config.set(state.values, field$5, Config.get(state.values, field$5).filter((param, i) => i !== index$1)),
                fieldsState: state.fieldsState
              }
            };
          case "FieldArrayRemoveBy" :
            let predicate = action._1;
            let field$6 = action._0;
            return {
              TAG: "Update",
              _0: {
                formState: state.formState,
                values: Config.set(state.values, field$6, Config.get(state.values, field$6).filter(entry => !predicate(entry))),
                fieldsState: state.fieldsState
              }
            };
          case "SetFormState" :
            return {
              TAG: "Update",
              _0: {
                formState: action._0,
                values: state.values,
                fieldsState: state.fieldsState
              }
            };
          case "SetValues" :
            return {
              TAG: "Update",
              _0: {
                formState: state.formState,
                values: action._0(state.values),
                fieldsState: state.fieldsState
              }
            };
          case "SetFieldValue" :
            return {
              TAG: "Update",
              _0: {
                formState: state.formState,
                values: Config.set(state.values, action._0, action._1),
                fieldsState: state.fieldsState
              }
            };
          case "RaiseSubmitFailed" :
            return {
              TAG: "Update",
              _0: {
                formState: {
                  TAG: "SubmitFailed",
                  _0: action._0
                },
                values: state.values,
                fieldsState: state.fieldsState
              }
            };
        }
      }
    }, {
      formState: "Pristine",
      values: initialState,
      fieldsState: getInitialFieldsState(schema)
    });
    let send = match[1];
    let state = match[0];
    let getFieldState = field => Stdlib_Option.mapOr(state.fieldsState.find(param => Primitive_object.equal(param[0], field)), "Pristine", param => param[1]);
    let getFieldError = field => {
      let error = getFieldState(field);
      if (typeof error !== "object" || error.TAG === "NestedErrors") {
        return;
      } else {
        return error._0;
      }
    };
    let validateFields = fields => {
      let fieldsValidated = ReSchema$1.validateFields(fields, state.values, i18n, schema);
      let newFieldsState = state.fieldsState.map(fieldStateItem => {
        let field = fieldStateItem[0];
        if (!fields.some(fieldItem => Primitive_object.equal(fieldItem, field))) {
          return [fieldStateItem];
        }
        let newFieldState = fieldsValidated.find(fieldStateValidated => Primitive_object.equal(Stdlib_Option.map(fieldStateValidated, param => param[0]), field));
        return Stdlib_Option.mapOr(Stdlib_Option.getOr(newFieldState, undefined), [], param => {
          let newFieldStateValidated = param[1];
          if (typeof newFieldStateValidated !== "object") {
            return [[
                field,
                "Valid"
              ]];
          } else if (newFieldStateValidated.TAG === "NestedErrors") {
            return [[
                field,
                {
                  TAG: "NestedErrors",
                  _0: newFieldStateValidated._0
                }
              ]];
          } else {
            return [[
                field,
                {
                  TAG: "Error",
                  _0: newFieldStateValidated._0
                }
              ]];
          }
        });
      }).flat();
      send({
        TAG: "SetFieldsState",
        _0: newFieldsState
      });
      return Stdlib_Array.filterMap(newFieldsState, param => {
        let field = param[0];
        if (fields.some(fieldItem => Primitive_object.equal(fieldItem, field))) {
          return param[1];
        }
      });
    };
    let raiseSubmitFailed = error => send({
      TAG: "RaiseSubmitFailed",
      _0: error
    });
    let getNestedFieldError = (field, index) => {
      let errors = getFieldState(field);
      if (typeof errors !== "object") {
        return;
      }
      if (errors.TAG !== "NestedErrors") {
        return;
      }
      let error = errors._0[index];
      if (error !== undefined) {
        return error.error;
      }
    };
    return {
      state: state,
      values: state.values,
      formState: state.formState,
      fieldsState: state.fieldsState,
      isSubmitting: state.formState === "Submitting",
      isDirty: state.formState === "Dirty",
      isPristine: state.formState === "Pristine",
      getFieldState: getFieldState,
      getFieldError: getFieldError,
      getNestedFieldError: getNestedFieldError,
      handleChange: (field, value) => send({
        TAG: "FieldChangeValue",
        _0: field,
        _1: value
      }),
      handleChangeWithCallback: (field, updateFn) => send({
        TAG: "FieldChangeValueWithCallback",
        _0: field,
        _1: updateFn
      }),
      arrayPush: (field, value) => send({
        TAG: "FieldArrayAdd",
        _0: field,
        _1: value
      }),
      arrayUpdateByIndex: (field, index, value) => send({
        TAG: "FieldArrayUpdateByIndex",
        _0: field,
        _1: value,
        _2: index
      }),
      arrayRemoveByIndex: (field, index) => send({
        TAG: "FieldArrayRemove",
        _0: field,
        _1: index
      }),
      arrayRemoveBy: (field, predicate) => send({
        TAG: "FieldArrayRemoveBy",
        _0: field,
        _1: predicate
      }),
      submit: () => send("TrySubmit"),
      resetForm: () => send("ResetForm"),
      setValues: fn => send({
        TAG: "SetValues",
        _0: fn
      }),
      setFieldValue: (field, value, shouldValidateOpt, param) => {
        let shouldValidate = shouldValidateOpt !== undefined ? shouldValidateOpt : true;
        if (shouldValidate) {
          return send({
            TAG: "FieldChangeValue",
            _0: field,
            _1: value
          });
        } else {
          return send({
            TAG: "SetFieldValue",
            _0: field,
            _1: value
          });
        }
      },
      validateField: field => send({
        TAG: "ValidateField",
        _0: field
      }),
      validateForm: () => send({
        TAG: "ValidateForm",
        _0: false
      }),
      validateFields: validateFields,
      raiseSubmitFailed: raiseSubmitFailed
    };
  };
  return {
    ReSchema: ReSchema$1,
    Validation: undefined,
    getInitialFieldsState: getInitialFieldsState,
    formContext: formContext,
    useFormContext: useFormContext,
    useField: useField,
    Provider: Provider,
    Field: Field,
    use: use
  };
}

let Helpers;

export {
  Helpers,
  Make,
}
/* react Not a pure module */
